<template>
  <div class="radish-list" v-loading="loading">
    <div style="height:30px">
      长期意向筛选：
      <el-radio v-model="yixiang" label="" @change="filterData">全部</el-radio>
      <el-radio v-model="yixiang" label="Y" @change="filterData">Y</el-radio>
      <el-radio v-model="yixiang" label="N" @change="filterData">N</el-radio>
      <el-radio v-model="yixiang" label="F" @change="filterData">F</el-radio>
    </div>
    <div ref="radishTableWapper" v-if="ready">
      <table class="a-table a-table-body" cellspacing="0" style="text-align:center">
        <tr>
          <th>#</th>
          <th v-if="hasReason" style="width:60px">原因</th>
          <template v-for="head in tableHeads">
            <th :style="{ width: head.width ? head.width + 'px' : '100px' }" :key="head.label + 'h'">
              {{ head.label }}
            </th>
          </template>
        </tr>
        <tr v-for="(item, index) in radishes" :key="'item' + index">
          <td>{{ index + 1 }}</td>
          <td v-if="hasReason" style="width:60px">{{item.reason}}</td>
          <template v-for="head in tableHeads">
            <a-td
              :style="{ width: head.width ? head.width + 'px' : '100px' }"
              :head="head"
              :item="item"
              :key="head.label + index + 'b'"
            ></a-td>
          </template>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import aTd from './table/a-td'
export default {
  components: { aTd },
  props: {
    ids: Array,
    contents: Array,
  },
  data: function() {
    return {
      ready: false,
      loading: false,
      radishes: [],
      query: {},
      activeRowId: '',
      fields: {
        姓名: 1,
        手机: 1,
        长期意向: 1,
        公司: 1,
        部门: 1,
        目前职位: 1,
        地域: 1,
        性别: 1,
        职能模块: 1,
        细分职能: 1,
        平台: 1,
        职级: 1,
        业绩: 1,
        擅长方向: 1,
        沟通日志: 1,
      },
      tableHeads: [
        {
          label: '姓名',
          type: 'link',
          width: 100,
          onClick: item => {
            this.clickName(item)
          },
        },
        { label: '长期意向' },
        { label: '公司', width: 120 },
        { label: '部门', width: 120 },
        { label: '目前职位' },
        {
          label: '沟通日志',
          type: 'tooltip',
          handleContent: function(content) {
            const res = content.replace(/(\d{4}\-\d{2}\-\d{2})/g,'\n<b>$1</b> ')
            return res
          }
        },
        { label: '地域', type: 'tag' },
        { label: '性别', width: 60 },
        { label: '职能模块', type: 'tag' },
        { label: '细分职能', type: 'tag' },
        { label: '平台', width: 60 },
        { label: '职级', width: 60 },
        { label: '业绩', width: 60 },
        { label: '擅长方向', type: 'tag' },
      ],
      yixiang: '',
      orgRadishes: [],
      hasReason: false,
    }
  },
  methods: {
    loadData: async function() {
      if (this.ids && this.ids.length > 0) {
        this.ready = false
        this.loading = true
        const res = await app.service('radish').simpleList({
          query: { _id: { $in: this.ids } },
          fields: this.fields,
        })
        this.ready = true
        if (res.status == 'success') {
          if (this.contents && this.contents.length > 0) {
            this.radishes = res.data.map(r=>{
              let content = this.contents.find(c => c.rid == r._id && c.reason == 'keyword')
              if (!content) content = this.contents.find(c => c.rid == r._id)
              if (content && content.reason) {
                if (!this.hasReason) this.hasReason = true
                r.reason = content.reason =='keyword'?'格式':'长度'
              }
              return r
            })
          } else {
            this.radishes = res.data
          }
          this.orgRadishes = JSON.parse(JSON.stringify(this.radishes))
        } else {
          console.log(res)
        }
        this.loading = false
      }
    },
    filterData() {
      this.loading = true
      this.ready = false
      const orgRadishes = JSON.parse(JSON.stringify(this.orgRadishes))
      this.radishes = this.yixiang ? orgRadishes.filter(r=>r.长期意向 == this.yixiang) : orgRadishes
      this.ready = true
      this.loading = false
    },
    clickName: async function(item) {
      window.open(`${window.frontend}/#/radish-detail-blank/${item._id}`, '_blank')
    },
  },
  watch: {
    ids: function() {
      this.loadData()
    },
  },
  mounted: async function() {
    this.loadData()
  },
}
</script>
